import axios from "axios";
const base_url = "https://youtube-v31.p.rapidapi.com";
export const options = {
  params: { 
    maxResults: "51", 
    part: 'snippet,id',
    regionCode: 'IN',

  },
  headers: {
    "X-RapidAPI-Key": "bd3adc3be3msh2b8620d6575c49ap1a0febjsn2f390c9cc280",
    "X-RapidAPI-Host": "youtube-v31.p.rapidapi.com",
  },
};

const fetchApi = async (url) => {
  try {
    const { data } = await axios.get(`${base_url}/${url}`, options);
    return data;
  } catch (error) {
    console.log("error in fetch api");
  }
};
export default fetchApi;
